import { memo } from 'react'

import css from './grid.module.scss'
import { IGrid } from './grid.type'


/** Сетка для выравнивания контента. */
export default memo(({children, className, gap, gridTemplate, gridTemplateColumns, gridTemplateRows, justifyContent, alignItems}: IGrid)  => {
    const getGridTemplate = () => {
        const gridTemplateColumnStyle: React.CSSProperties = {
            gap: gap,
            alignItems: alignItems,
            justifyContent: justifyContent,
            gridTemplateColumns: gridTemplateColumns,
        }

        const gridTemplateRowsStyle: React.CSSProperties = {
            gap: gap,
            alignItems: alignItems,
            justifyContent: justifyContent,
            gridTemplateRows: gridTemplateRows,
        }

        switch (gridTemplate) {
            case 'columns': return gridTemplateColumnStyle
            case 'rows': return gridTemplateRowsStyle
            default: return gridTemplateColumnStyle
        }
    }


    return <div style={getGridTemplate()} className={`${css.grid} ${className}`}>
        {children}
    </div>
})